import type { CSSProperties } from 'react'

export function Skeleton({
  w = '100%',
  h = 14,
  radius = 8,
  style,
}: { w?: number | string; h?: number | string; radius?: number; style?: CSSProperties }) {
  return (
    <span
      className="skeleton"
      aria-hidden="true"
      style={{ width: w, height: h, borderRadius: radius, display: 'block', ...style }}
    />
  )
}

export function SkeletonRows({ rows = 5 }: { rows?: number }) {
  return (
    <div className="stack" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} h={18} />
      ))}
    </div>
  )
}
